/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { AddUserToGroupDtoToJSON, } from '../models/AddUserToGroupDto';
import { AnnouncementControllerUpload200ResponseFromJSON, } from '../models/AnnouncementControllerUpload200Response';
import { AnnouncementDtoFromJSON, } from '../models/AnnouncementDto';
import { ApiApplicationToJSON, } from '../models/ApiApplication';
import { ApplicationModificationDtoToJSON, } from '../models/ApplicationModificationDto';
import { ApplicationTokenDtoFromJSON, } from '../models/ApplicationTokenDto';
import { BugReportDtoToJSON, } from '../models/BugReportDto';
import { BulkTracksRequestDtoToJSON, } from '../models/BulkTracksRequestDto';
import { BulkTracksResponseDtoFromJSON, } from '../models/BulkTracksResponseDto';
import { CHChartDtoFromJSON, } from '../models/CHChartDto';
import { CHChartsDtoFromJSON, } from '../models/CHChartsDto';
import { CopyFolderDtoToJSON, } from '../models/CopyFolderDto';
import { CrateCategoryDtoFromJSON, CrateCategoryDtoToJSON, } from '../models/CrateCategoryDto';
import { CrateImageUrlDtoFromJSON, } from '../models/CrateImageUrlDto';
import { CrateSearchDtoToJSON, } from '../models/CrateSearchDto';
import { CreateAnnouncementDtoToJSON, } from '../models/CreateAnnouncementDto';
import { CreateCustomFolderDtoToJSON, } from '../models/CreateCustomFolderDto';
import { CreateFolderCrateDtoToJSON, } from '../models/CreateFolderCrateDto';
import { CreateFolderDtoToJSON, } from '../models/CreateFolderDto';
import { CreateKnownIssueDtoToJSON, } from '../models/CreateKnownIssueDto';
import { CreateModifyGroupDtoToJSON, } from '../models/CreateModifyGroupDto';
import { CreateTutorialVideoDtoToJSON, } from '../models/CreateTutorialVideoDto';
import { DMSAuthUrlResponseDtoFromJSON, } from '../models/DMSAuthUrlResponseDto';
import { DMSExchangeTokenDtoToJSON, } from '../models/DMSExchangeTokenDto';
import { DMSStatusResponseDtoFromJSON, } from '../models/DMSStatusResponseDto';
import { DMSTokenResponseDtoFromJSON, } from '../models/DMSTokenResponseDto';
import { DmsDownloadDtoToJSON, } from '../models/DmsDownloadDto';
import { DmsUrlResponseDtoFromJSON, } from '../models/DmsUrlResponseDto';
import { EventDetailDtoFromJSON, } from '../models/EventDetailDto';
import { EventsDtoFromJSON, } from '../models/EventsDto';
import { FeatureRequestDtoToJSON, } from '../models/FeatureRequestDto';
import { ForgotPasswordDtoToJSON, } from '../models/ForgotPasswordDto';
import { GenerateCrateRequestDtoToJSON, } from '../models/GenerateCrateRequestDto';
import { GetCategoryDtoToJSON, } from '../models/GetCategoryDto';
import { GetCrateDtoFromJSON, } from '../models/GetCrateDto';
import { GetCratesDtoFromJSON, } from '../models/GetCratesDto';
import { GetEventsDtoToJSON, } from '../models/GetEventsDto';
import { GetSimpleCrateDtoFromJSON, } from '../models/GetSimpleCrateDto';
import { GroupControllerUpdateUserGroupPermissionRequestToJSON, } from '../models/GroupControllerUpdateUserGroupPermissionRequest';
import { IntegrationDtoToJSON, } from '../models/IntegrationDto';
import { IntegrationStatusDtoFromJSON, } from '../models/IntegrationStatusDto';
import { KartraGenericDtoToJSON, } from '../models/KartraGenericDto';
import { KeyDtoToJSON, } from '../models/KeyDto';
import { KnownIssueDtoFromJSON, } from '../models/KnownIssueDto';
import { LNRPDownloadDtoToJSON, } from '../models/LNRPDownloadDto';
import { LnrpDownloadResponseDtoFromJSON, } from '../models/LnrpDownloadResponseDto';
import { LnrpLoginDtoToJSON, } from '../models/LnrpLoginDto';
import { LnrpLoginResponseDtoFromJSON, } from '../models/LnrpLoginResponseDto';
import { LoginEmailPasswordDtoToJSON, } from '../models/LoginEmailPasswordDto';
import { MoveCrateFolderDtoToJSON, } from '../models/MoveCrateFolderDto';
import { MoveFolderDtoToJSON, } from '../models/MoveFolderDto';
import { MyAlbumIdRequestDtoToJSON, } from '../models/MyAlbumIdRequestDto';
import { MyAlbumInfoIdRequestDtoToJSON, } from '../models/MyAlbumInfoIdRequestDto';
import { MyPlaylistIdRequestDtoToJSON, } from '../models/MyPlaylistIdRequestDto';
import { MyPlaylistInfoIdRequestDtoToJSON, } from '../models/MyPlaylistInfoIdRequestDto';
import { MyPlaylistsRequestDtoToJSON, } from '../models/MyPlaylistsRequestDto';
import { PaginatedTrackResponseFromJSON, } from '../models/PaginatedTrackResponse';
import { PoolListDtoFromJSON, } from '../models/PoolListDto';
import { PoolSearchDtoToJSON, } from '../models/PoolSearchDto';
import { PoolTrackDataDtoFromJSON, } from '../models/PoolTrackDataDto';
import { RefreshBubbleTokenDtoToJSON, } from '../models/RefreshBubbleTokenDto';
import { RegenerateTokensDtoToJSON, } from '../models/RegenerateTokensDto';
import { RegisterDtoToJSON, } from '../models/RegisterDto';
import { ResetPasswordDtoToJSON, } from '../models/ResetPasswordDto';
import { ReturnGroupDtoFromJSON, } from '../models/ReturnGroupDto';
import { ReturnPaginatedDataDtoFromJSON, } from '../models/ReturnPaginatedDataDto';
import { SearchDtoToJSON, } from '../models/SearchDto';
import { SetLifetimeMembersDtoToJSON, } from '../models/SetLifetimeMembersDto';
import { SpotifySearchDtoToJSON, } from '../models/SpotifySearchDto';
import { SyncTrackFeaturesRequestDtoToJSON, } from '../models/SyncTrackFeaturesRequestDto';
import { SyncTrackFeaturesResponseDtoFromJSON, } from '../models/SyncTrackFeaturesResponseDto';
import { TrackFromJSON, } from '../models/Track';
import { TrackAvailabilityOptionsDtoFromJSON, } from '../models/TrackAvailabilityOptionsDto';
import { TrackCrateSearchDtoToJSON, } from '../models/TrackCrateSearchDto';
import { TrackFeaturesResponseDtoFromJSON, } from '../models/TrackFeaturesResponseDto';
import { TrackSearchDtoFromJSON, } from '../models/TrackSearchDto';
import { TutorialVideoDtoFromJSON, } from '../models/TutorialVideoDto';
import { UpdateAnnouncementDtoToJSON, } from '../models/UpdateAnnouncementDto';
import { UpdateCrateDtoToJSON, } from '../models/UpdateCrateDto';
import { UpdateCustomFolderDtoToJSON, } from '../models/UpdateCustomFolderDto';
import { UpdateFolderDtoToJSON, } from '../models/UpdateFolderDto';
import { UpdateKnownIssueDtoToJSON, } from '../models/UpdateKnownIssueDto';
import { UpdateTutorialVideoDtoToJSON, } from '../models/UpdateTutorialVideoDto';
import { UpdateUserDjSoftwareDtoToJSON, } from '../models/UpdateUserDjSoftwareDto';
import { UserFromJSON, } from '../models/User';
/**
 *
 */
export class DefaultApi extends runtime.BaseAPI {
    /**
     * Creates request options for aiCrateControllerGenerate without sending the request
     */
    aiCrateControllerGenerateRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['generateCrateRequestDto'] == null) {
                throw new runtime.RequiredError('generateCrateRequestDto', 'Required parameter "generateCrateRequestDto" was null or undefined when calling aiCrateControllerGenerate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/ai-crate/generate`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: GenerateCrateRequestDtoToJSON(requestParameters['generateCrateRequestDto']),
            };
        });
    }
    /**
     * Generate a mixable crate from a natural-language prompt. Responds as a Server-Sent Events stream (progress events followed by a final result).
     */
    aiCrateControllerGenerateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.aiCrateControllerGenerateRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Generate a mixable crate from a natural-language prompt. Responds as a Server-Sent Events stream (progress events followed by a final result).
     */
    aiCrateControllerGenerate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.aiCrateControllerGenerateRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for announcementControllerCreate without sending the request
     */
    announcementControllerCreateRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['createAnnouncementDto'] == null) {
                throw new runtime.RequiredError('createAnnouncementDto', 'Required parameter "createAnnouncementDto" was null or undefined when calling announcementControllerCreate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/announcements`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateAnnouncementDtoToJSON(requestParameters['createAnnouncementDto']),
            };
        });
    }
    /**
     */
    announcementControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.announcementControllerCreateRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => AnnouncementDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    announcementControllerCreate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.announcementControllerCreateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for announcementControllerListActive without sending the request
     */
    announcementControllerListActiveRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/announcements`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    announcementControllerListActiveRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.announcementControllerListActiveRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AnnouncementDtoFromJSON));
        });
    }
    /**
     */
    announcementControllerListActive(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.announcementControllerListActiveRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for announcementControllerListAll without sending the request
     */
    announcementControllerListAllRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/announcements/all`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    announcementControllerListAllRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.announcementControllerListAllRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AnnouncementDtoFromJSON));
        });
    }
    /**
     */
    announcementControllerListAll(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.announcementControllerListAllRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for announcementControllerRemove without sending the request
     */
    announcementControllerRemoveRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling announcementControllerRemove().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/announcements/{id}`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    announcementControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.announcementControllerRemoveRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    announcementControllerRemove(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.announcementControllerRemoveRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for announcementControllerRemovePermanent without sending the request
     */
    announcementControllerRemovePermanentRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling announcementControllerRemovePermanent().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/announcements/{id}/permanent`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    announcementControllerRemovePermanentRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.announcementControllerRemovePermanentRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    announcementControllerRemovePermanent(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.announcementControllerRemovePermanentRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for announcementControllerUpdate without sending the request
     */
    announcementControllerUpdateRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling announcementControllerUpdate().');
            }
            if (requestParameters['updateAnnouncementDto'] == null) {
                throw new runtime.RequiredError('updateAnnouncementDto', 'Required parameter "updateAnnouncementDto" was null or undefined when calling announcementControllerUpdate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/announcements/{id}`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: UpdateAnnouncementDtoToJSON(requestParameters['updateAnnouncementDto']),
            };
        });
    }
    /**
     */
    announcementControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.announcementControllerUpdateRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => AnnouncementDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    announcementControllerUpdate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.announcementControllerUpdateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for announcementControllerUpload without sending the request
     */
    announcementControllerUploadRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters['file'] != null) {
                formParams.append('file', requestParameters['file']);
            }
            let urlPath = `/announcements/upload`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            };
        });
    }
    /**
     */
    announcementControllerUploadRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.announcementControllerUploadRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => AnnouncementControllerUpload200ResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    announcementControllerUpload(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.announcementControllerUploadRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for applicationControllerApplyForApiAccess without sending the request
     */
    applicationControllerApplyForApiAccessRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['apiApplication'] == null) {
                throw new runtime.RequiredError('apiApplication', 'Required parameter "apiApplication" was null or undefined when calling applicationControllerApplyForApiAccess().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/application/apply`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ApiApplicationToJSON(requestParameters['apiApplication']),
            };
        });
    }
    /**
     */
    applicationControllerApplyForApiAccessRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.applicationControllerApplyForApiAccessRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    applicationControllerApplyForApiAccess(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.applicationControllerApplyForApiAccessRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for applicationControllerListApplications without sending the request
     */
    applicationControllerListApplicationsRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/application/list`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    applicationControllerListApplicationsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.applicationControllerListApplicationsRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    applicationControllerListApplications(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.applicationControllerListApplicationsRaw(initOverrides);
        });
    }
    /**
     * Creates request options for applicationControllerManageApplication without sending the request
     */
    applicationControllerManageApplicationRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['applicationModificationDto'] == null) {
                throw new runtime.RequiredError('applicationModificationDto', 'Required parameter "applicationModificationDto" was null or undefined when calling applicationControllerManageApplication().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/application/manage`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ApplicationModificationDtoToJSON(requestParameters['applicationModificationDto']),
            };
        });
    }
    /**
     */
    applicationControllerManageApplicationRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.applicationControllerManageApplicationRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    applicationControllerManageApplication(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.applicationControllerManageApplicationRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for applicationControllerRefreshApplicationToken without sending the request
     */
    applicationControllerRefreshApplicationTokenRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/application/refresh-token`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    applicationControllerRefreshApplicationTokenRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.applicationControllerRefreshApplicationTokenRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationTokenDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    applicationControllerRefreshApplicationToken(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.applicationControllerRefreshApplicationTokenRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for applicationControllerRegenerateTokens without sending the request
     */
    applicationControllerRegenerateTokensRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['regenerateTokensDto'] == null) {
                throw new runtime.RequiredError('regenerateTokensDto', 'Required parameter "regenerateTokensDto" was null or undefined when calling applicationControllerRegenerateTokens().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/application/regenerate-tokens`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: RegenerateTokensDtoToJSON(requestParameters['regenerateTokensDto']),
            };
        });
    }
    /**
     */
    applicationControllerRegenerateTokensRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.applicationControllerRegenerateTokensRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApplicationTokenDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    applicationControllerRegenerateTokens(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.applicationControllerRegenerateTokensRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for authControllerForgotPassword without sending the request
     */
    authControllerForgotPasswordRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['forgotPasswordDto'] == null) {
                throw new runtime.RequiredError('forgotPasswordDto', 'Required parameter "forgotPasswordDto" was null or undefined when calling authControllerForgotPassword().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/auth/forgot-password`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ForgotPasswordDtoToJSON(requestParameters['forgotPasswordDto']),
            };
        });
    }
    /**
     */
    authControllerForgotPasswordRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.authControllerForgotPasswordRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    authControllerForgotPassword(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.authControllerForgotPasswordRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for authControllerLogin without sending the request
     */
    authControllerLoginRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['loginEmailPasswordDto'] == null) {
                throw new runtime.RequiredError('loginEmailPasswordDto', 'Required parameter "loginEmailPasswordDto" was null or undefined when calling authControllerLogin().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/auth/login`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: LoginEmailPasswordDtoToJSON(requestParameters['loginEmailPasswordDto']),
            };
        });
    }
    /**
     */
    authControllerLoginRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.authControllerLoginRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    authControllerLogin(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authControllerLoginRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for authControllerRefreshBubbleToken without sending the request
     */
    authControllerRefreshBubbleTokenRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['refreshBubbleTokenDto'] == null) {
                throw new runtime.RequiredError('refreshBubbleTokenDto', 'Required parameter "refreshBubbleTokenDto" was null or undefined when calling authControllerRefreshBubbleToken().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/auth/refreshBubbleToken`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: RefreshBubbleTokenDtoToJSON(requestParameters['refreshBubbleTokenDto']),
            };
        });
    }
    /**
     */
    authControllerRefreshBubbleTokenRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.authControllerRefreshBubbleTokenRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    authControllerRefreshBubbleToken(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authControllerRefreshBubbleTokenRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for authControllerRefreshSubscriptions without sending the request
     */
    authControllerRefreshSubscriptionsRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/auth/refresh-subscriptions`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    authControllerRefreshSubscriptionsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.authControllerRefreshSubscriptionsRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    authControllerRefreshSubscriptions(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.authControllerRefreshSubscriptionsRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for authControllerRegister without sending the request
     */
    authControllerRegisterRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['registerDto'] == null) {
                throw new runtime.RequiredError('registerDto', 'Required parameter "registerDto" was null or undefined when calling authControllerRegister().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/auth/register`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: RegisterDtoToJSON(requestParameters['registerDto']),
            };
        });
    }
    /**
     */
    authControllerRegisterRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.authControllerRegisterRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    authControllerRegister(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.authControllerRegisterRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for authControllerResetPassword without sending the request
     */
    authControllerResetPasswordRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['resetPasswordDto'] == null) {
                throw new runtime.RequiredError('resetPasswordDto', 'Required parameter "resetPasswordDto" was null or undefined when calling authControllerResetPassword().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/auth/reset-password`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ResetPasswordDtoToJSON(requestParameters['resetPasswordDto']),
            };
        });
    }
    /**
     */
    authControllerResetPasswordRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.authControllerResetPasswordRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    authControllerResetPassword(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.authControllerResetPasswordRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for authControllerVerify without sending the request
     */
    authControllerVerifyRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['token'] == null) {
                throw new runtime.RequiredError('token', 'Required parameter "token" was null or undefined when calling authControllerVerify().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/auth/verify/{token}`;
            urlPath = urlPath.replace('{token}', encodeURIComponent(String(requestParameters['token'])));
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    authControllerVerifyRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.authControllerVerifyRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    authControllerVerify(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.authControllerVerifyRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for chartControllerGetCHChart without sending the request
     */
    chartControllerGetCHChartRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling chartControllerGetCHChart().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/charts/{id}`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    chartControllerGetCHChartRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.chartControllerGetCHChartRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CHChartDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    chartControllerGetCHChart(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.chartControllerGetCHChartRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for chartControllerGetCHCharts without sending the request
     */
    chartControllerGetCHChartsRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/charts`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    chartControllerGetCHChartsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.chartControllerGetCHChartsRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CHChartsDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    chartControllerGetCHCharts(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.chartControllerGetCHChartsRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for crateControllerCreateCrate without sending the request
     */
    crateControllerCreateCrateRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['body'] == null) {
                throw new runtime.RequiredError('body', 'Required parameter "body" was null or undefined when calling crateControllerCreateCrate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/crates`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['body'],
            };
        });
    }
    /**
     */
    crateControllerCreateCrateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.crateControllerCreateCrateRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    crateControllerCreateCrate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.crateControllerCreateCrateRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for crateControllerDeleteCrate without sending the request
     */
    crateControllerDeleteCrateRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling crateControllerDeleteCrate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/crates/{id}`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    crateControllerDeleteCrateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.crateControllerDeleteCrateRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    crateControllerDeleteCrate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.crateControllerDeleteCrateRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for crateControllerFindCuratedCrates without sending the request
     */
    crateControllerFindCuratedCratesRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['cursor'] != null) {
                queryParameters['cursor'] = requestParameters['cursor'];
            }
            if (requestParameters['archived'] != null) {
                queryParameters['archived'] = requestParameters['archived'];
            }
            if (requestParameters['ignoreCache'] != null) {
                queryParameters['ignoreCache'] = requestParameters['ignoreCache'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/crates/curated`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    crateControllerFindCuratedCratesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.crateControllerFindCuratedCratesRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetCratesDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    crateControllerFindCuratedCrates(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.crateControllerFindCuratedCratesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for crateControllerFindHackathon without sending the request
     */
    crateControllerFindHackathonRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/crates/hackathon`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    crateControllerFindHackathonRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.crateControllerFindHackathonRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    crateControllerFindHackathon(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.crateControllerFindHackathonRaw(initOverrides);
        });
    }
    /**
     * Creates request options for crateControllerFindMarketplace without sending the request
     */
    crateControllerFindMarketplaceRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/crates/marketplace`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    crateControllerFindMarketplaceRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.crateControllerFindMarketplaceRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    crateControllerFindMarketplace(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.crateControllerFindMarketplaceRaw(initOverrides);
        });
    }
    /**
     * Creates request options for crateControllerFindMyCrates without sending the request
     */
    crateControllerFindMyCratesRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/crates/my-crates`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    crateControllerFindMyCratesRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.crateControllerFindMyCratesRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    crateControllerFindMyCrates(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.crateControllerFindMyCratesRaw(initOverrides);
        });
    }
    /**
     * Creates request options for crateControllerFindMyCratesWithGroups without sending the request
     */
    crateControllerFindMyCratesWithGroupsRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/crates/my-crates-with-groups`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    crateControllerFindMyCratesWithGroupsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.crateControllerFindMyCratesWithGroupsRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    crateControllerFindMyCratesWithGroups(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.crateControllerFindMyCratesWithGroupsRaw(initOverrides);
        });
    }
    /**
     * Creates request options for crateControllerFindOne without sending the request
     */
    crateControllerFindOneRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling crateControllerFindOne().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/crates/{id}`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    crateControllerFindOneRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.crateControllerFindOneRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    crateControllerFindOne(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.crateControllerFindOneRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for crateControllerFindStandard without sending the request
     */
    crateControllerFindStandardRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/crates/standard`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    crateControllerFindStandardRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.crateControllerFindStandardRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    crateControllerFindStandard(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.crateControllerFindStandardRaw(initOverrides);
        });
    }
    /**
     * Creates request options for crateControllerGetCategoryById without sending the request
     */
    crateControllerGetCategoryByIdRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['getCategoryDto'] == null) {
                throw new runtime.RequiredError('getCategoryDto', 'Required parameter "getCategoryDto" was null or undefined when calling crateControllerGetCategoryById().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/crates/category`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: GetCategoryDtoToJSON(requestParameters['getCategoryDto']),
            };
        });
    }
    /**
     */
    crateControllerGetCategoryByIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.crateControllerGetCategoryByIdRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CrateCategoryDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    crateControllerGetCategoryById(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.crateControllerGetCategoryByIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for crateControllerGetCrateCategories without sending the request
     */
    crateControllerGetCrateCategoriesRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/crates/categories`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    crateControllerGetCrateCategoriesRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.crateControllerGetCrateCategoriesRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CrateCategoryDtoFromJSON));
        });
    }
    /**
     */
    crateControllerGetCrateCategories(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.crateControllerGetCrateCategoriesRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for crateControllerGetCratesByCategory without sending the request
     */
    crateControllerGetCratesByCategoryRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['crateCategoryDto'] == null) {
                throw new runtime.RequiredError('crateCategoryDto', 'Required parameter "crateCategoryDto" was null or undefined when calling crateControllerGetCratesByCategory().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/crates/category-crates`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CrateCategoryDtoToJSON(requestParameters['crateCategoryDto']),
            };
        });
    }
    /**
     */
    crateControllerGetCratesByCategoryRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.crateControllerGetCratesByCategoryRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetCratesDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    crateControllerGetCratesByCategory(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.crateControllerGetCratesByCategoryRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for crateControllerGetCratesByGroup without sending the request
     */
    crateControllerGetCratesByGroupRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['groupId'] == null) {
                throw new runtime.RequiredError('groupId', 'Required parameter "groupId" was null or undefined when calling crateControllerGetCratesByGroup().');
            }
            const queryParameters = {};
            if (requestParameters['archived'] != null) {
                queryParameters['archived'] = requestParameters['archived'];
            }
            if (requestParameters['limit'] != null) {
                queryParameters['limit'] = requestParameters['limit'];
            }
            if (requestParameters['page'] != null) {
                queryParameters['page'] = requestParameters['page'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/crates/group/{groupId}`;
            urlPath = urlPath.replace('{groupId}', encodeURIComponent(String(requestParameters['groupId'])));
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    crateControllerGetCratesByGroupRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.crateControllerGetCratesByGroupRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ReturnPaginatedDataDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    crateControllerGetCratesByGroup(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.crateControllerGetCratesByGroupRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for crateControllerIncrementSave without sending the request
     */
    crateControllerIncrementSaveRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling crateControllerIncrementSave().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/crates/{id}/increment-save`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    crateControllerIncrementSaveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.crateControllerIncrementSaveRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    crateControllerIncrementSave(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.crateControllerIncrementSaveRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for crateControllerIncrementView without sending the request
     */
    crateControllerIncrementViewRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling crateControllerIncrementView().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/crates/{id}/increment-view`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    crateControllerIncrementViewRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.crateControllerIncrementViewRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    crateControllerIncrementView(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.crateControllerIncrementViewRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for crateControllerSearch without sending the request
     */
    crateControllerSearchRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['crateSearchDto'] == null) {
                throw new runtime.RequiredError('crateSearchDto', 'Required parameter "crateSearchDto" was null or undefined when calling crateControllerSearch().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/crates/search`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CrateSearchDtoToJSON(requestParameters['crateSearchDto']),
            };
        });
    }
    /**
     */
    crateControllerSearchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.crateControllerSearchRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetCratesDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    crateControllerSearch(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.crateControllerSearchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for crateControllerUpdateCrate without sending the request
     */
    crateControllerUpdateCrateRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling crateControllerUpdateCrate().');
            }
            if (requestParameters['updateCrateDto'] == null) {
                throw new runtime.RequiredError('updateCrateDto', 'Required parameter "updateCrateDto" was null or undefined when calling crateControllerUpdateCrate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/crates/{id}`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: UpdateCrateDtoToJSON(requestParameters['updateCrateDto']),
            };
        });
    }
    /**
     */
    crateControllerUpdateCrateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.crateControllerUpdateCrateRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => GetCrateDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    crateControllerUpdateCrate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.crateControllerUpdateCrateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for crateControllerUploadCrateImage without sending the request
     */
    crateControllerUploadCrateImageRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters['file'] != null) {
                formParams.append('file', requestParameters['file']);
            }
            let urlPath = `/crates/upload-image`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            };
        });
    }
    /**
     */
    crateControllerUploadCrateImageRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.crateControllerUploadCrateImageRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CrateImageUrlDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    crateControllerUploadCrateImage(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.crateControllerUploadCrateImageRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for djepControllerCheckIntegraion without sending the request
     */
    djepControllerCheckIntegraionRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/djep/check-integration`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    djepControllerCheckIntegraionRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.djepControllerCheckIntegraionRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => IntegrationStatusDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    djepControllerCheckIntegraion(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.djepControllerCheckIntegraionRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for djepControllerGetEvent without sending the request
     */
    djepControllerGetEventRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling djepControllerGetEvent().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/djep/event/{id}`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    djepControllerGetEventRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.djepControllerGetEventRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => EventDetailDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    djepControllerGetEvent(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.djepControllerGetEventRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for djepControllerGetEvents without sending the request
     */
    djepControllerGetEventsRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['getEventsDto'] == null) {
                throw new runtime.RequiredError('getEventsDto', 'Required parameter "getEventsDto" was null or undefined when calling djepControllerGetEvents().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/djep/events`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: GetEventsDtoToJSON(requestParameters['getEventsDto']),
            };
        });
    }
    /**
     */
    djepControllerGetEventsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.djepControllerGetEventsRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => EventsDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    djepControllerGetEvents(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.djepControllerGetEventsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for djepControllerIntegrate without sending the request
     */
    djepControllerIntegrateRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['integrationDto'] == null) {
                throw new runtime.RequiredError('integrationDto', 'Required parameter "integrationDto" was null or undefined when calling djepControllerIntegrate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/djep/integrate`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: IntegrationDtoToJSON(requestParameters['integrationDto']),
            };
        });
    }
    /**
     */
    djepControllerIntegrateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.djepControllerIntegrateRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    djepControllerIntegrate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.djepControllerIntegrateRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for djepControllerRemoveIntegration without sending the request
     */
    djepControllerRemoveIntegrationRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/djep/remove-integration`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    djepControllerRemoveIntegrationRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.djepControllerRemoveIntegrationRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => IntegrationStatusDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    djepControllerRemoveIntegration(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.djepControllerRemoveIntegrationRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for dmsControllerExchange without sending the request
     */
    dmsControllerExchangeRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['dMSExchangeTokenDto'] == null) {
                throw new runtime.RequiredError('dMSExchangeTokenDto', 'Required parameter "dMSExchangeTokenDto" was null or undefined when calling dmsControllerExchange().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/dms/token`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: DMSExchangeTokenDtoToJSON(requestParameters['dMSExchangeTokenDto']),
            };
        });
    }
    /**
     */
    dmsControllerExchangeRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.dmsControllerExchangeRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DMSTokenResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    dmsControllerExchange(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dmsControllerExchangeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for dmsControllerGetAuthUrl without sending the request
     */
    dmsControllerGetAuthUrlRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/dms/auth-url`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    dmsControllerGetAuthUrlRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.dmsControllerGetAuthUrlRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DMSAuthUrlResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    dmsControllerGetAuthUrl(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dmsControllerGetAuthUrlRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for dmsControllerGetDownloadUrl without sending the request
     */
    dmsControllerGetDownloadUrlRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['dmsDownloadDto'] == null) {
                throw new runtime.RequiredError('dmsDownloadDto', 'Required parameter "dmsDownloadDto" was null or undefined when calling dmsControllerGetDownloadUrl().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/dms/download-url`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: DmsDownloadDtoToJSON(requestParameters['dmsDownloadDto']),
            };
        });
    }
    /**
     */
    dmsControllerGetDownloadUrlRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.dmsControllerGetDownloadUrlRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DmsUrlResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    dmsControllerGetDownloadUrl(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dmsControllerGetDownloadUrlRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for dmsControllerGetPreviewUrl without sending the request
     */
    dmsControllerGetPreviewUrlRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['dmsDownloadDto'] == null) {
                throw new runtime.RequiredError('dmsDownloadDto', 'Required parameter "dmsDownloadDto" was null or undefined when calling dmsControllerGetPreviewUrl().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/dms/preview-url`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: DmsDownloadDtoToJSON(requestParameters['dmsDownloadDto']),
            };
        });
    }
    /**
     */
    dmsControllerGetPreviewUrlRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.dmsControllerGetPreviewUrlRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DmsUrlResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    dmsControllerGetPreviewUrl(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dmsControllerGetPreviewUrlRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for dmsControllerLogout without sending the request
     */
    dmsControllerLogoutRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/dms/logout`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    dmsControllerLogoutRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.dmsControllerLogoutRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DMSTokenResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    dmsControllerLogout(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dmsControllerLogoutRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for dmsControllerRefresh without sending the request
     */
    dmsControllerRefreshRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/dms/refresh`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    dmsControllerRefreshRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.dmsControllerRefreshRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DMSTokenResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    dmsControllerRefresh(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dmsControllerRefreshRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for dmsControllerStatus without sending the request
     */
    dmsControllerStatusRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/dms/status`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    dmsControllerStatusRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.dmsControllerStatusRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DMSStatusResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    dmsControllerStatus(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.dmsControllerStatusRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for feedbackControllerFeatureRequest without sending the request
     */
    feedbackControllerFeatureRequestRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['featureRequestDto'] == null) {
                throw new runtime.RequiredError('featureRequestDto', 'Required parameter "featureRequestDto" was null or undefined when calling feedbackControllerFeatureRequest().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/feedback/feature-request`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: FeatureRequestDtoToJSON(requestParameters['featureRequestDto']),
            };
        });
    }
    /**
     */
    feedbackControllerFeatureRequestRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.feedbackControllerFeatureRequestRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    feedbackControllerFeatureRequest(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.feedbackControllerFeatureRequestRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for feedbackControllerReportBug without sending the request
     */
    feedbackControllerReportBugRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['bugReportDto'] == null) {
                throw new runtime.RequiredError('bugReportDto', 'Required parameter "bugReportDto" was null or undefined when calling feedbackControllerReportBug().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/feedback/bug-report`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: BugReportDtoToJSON(requestParameters['bugReportDto']),
            };
        });
    }
    /**
     */
    feedbackControllerReportBugRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.feedbackControllerReportBugRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    feedbackControllerReportBug(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.feedbackControllerReportBugRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for folderControllerCopyFolder without sending the request
     */
    folderControllerCopyFolderRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['copyFolderDto'] == null) {
                throw new runtime.RequiredError('copyFolderDto', 'Required parameter "copyFolderDto" was null or undefined when calling folderControllerCopyFolder().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/folder/copy`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CopyFolderDtoToJSON(requestParameters['copyFolderDto']),
            };
        });
    }
    /**
     */
    folderControllerCopyFolderRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.folderControllerCopyFolderRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    folderControllerCopyFolder(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.folderControllerCopyFolderRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for folderControllerCreate without sending the request
     */
    folderControllerCreateRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['createFolderDto'] == null) {
                throw new runtime.RequiredError('createFolderDto', 'Required parameter "createFolderDto" was null or undefined when calling folderControllerCreate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/folder`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateFolderDtoToJSON(requestParameters['createFolderDto']),
            };
        });
    }
    /**
     */
    folderControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.folderControllerCreateRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    folderControllerCreate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.folderControllerCreateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for folderControllerCreateCrate without sending the request
     */
    folderControllerCreateCrateRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['createFolderCrateDto'] == null) {
                throw new runtime.RequiredError('createFolderCrateDto', 'Required parameter "createFolderCrateDto" was null or undefined when calling folderControllerCreateCrate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/folder/crate`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateFolderCrateDtoToJSON(requestParameters['createFolderCrateDto']),
            };
        });
    }
    /**
     */
    folderControllerCreateCrateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.folderControllerCreateCrateRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    folderControllerCreateCrate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.folderControllerCreateCrateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for folderControllerCreateCustomFolder without sending the request
     */
    folderControllerCreateCustomFolderRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['createCustomFolderDto'] == null) {
                throw new runtime.RequiredError('createCustomFolderDto', 'Required parameter "createCustomFolderDto" was null or undefined when calling folderControllerCreateCustomFolder().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/folder/customFolder`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateCustomFolderDtoToJSON(requestParameters['createCustomFolderDto']),
            };
        });
    }
    /**
     */
    folderControllerCreateCustomFolderRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.folderControllerCreateCustomFolderRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    folderControllerCreateCustomFolder(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.folderControllerCreateCustomFolderRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for folderControllerCreateDefaultFolder without sending the request
     */
    folderControllerCreateDefaultFolderRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/folder/createDefault`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    folderControllerCreateDefaultFolderRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.folderControllerCreateDefaultFolderRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    folderControllerCreateDefaultFolder(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.folderControllerCreateDefaultFolderRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for folderControllerFindAll without sending the request
     */
    folderControllerFindAllRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/folder`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    folderControllerFindAllRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.folderControllerFindAllRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    folderControllerFindAll(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.folderControllerFindAllRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for folderControllerFindAllCrates without sending the request
     */
    folderControllerFindAllCratesRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/folder/crate`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    folderControllerFindAllCratesRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.folderControllerFindAllCratesRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    folderControllerFindAllCrates(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.folderControllerFindAllCratesRaw(initOverrides);
        });
    }
    /**
     * Creates request options for folderControllerFindAllCustomFolder without sending the request
     */
    folderControllerFindAllCustomFolderRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/folder/customFolder`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    folderControllerFindAllCustomFolderRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.folderControllerFindAllCustomFolderRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    folderControllerFindAllCustomFolder(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.folderControllerFindAllCustomFolderRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for folderControllerFindOne without sending the request
     */
    folderControllerFindOneRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling folderControllerFindOne().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/folder/{id}`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    folderControllerFindOneRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.folderControllerFindOneRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    folderControllerFindOne(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.folderControllerFindOneRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for folderControllerFindOneCustomFolder without sending the request
     */
    folderControllerFindOneCustomFolderRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling folderControllerFindOneCustomFolder().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/folder/custom-folder/{id}`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    folderControllerFindOneCustomFolderRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.folderControllerFindOneCustomFolderRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    folderControllerFindOneCustomFolder(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.folderControllerFindOneCustomFolderRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for folderControllerMoveCrateFolder without sending the request
     */
    folderControllerMoveCrateFolderRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['moveCrateFolderDto'] == null) {
                throw new runtime.RequiredError('moveCrateFolderDto', 'Required parameter "moveCrateFolderDto" was null or undefined when calling folderControllerMoveCrateFolder().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/folder/crate/move`;
            return {
                path: urlPath,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: MoveCrateFolderDtoToJSON(requestParameters['moveCrateFolderDto']),
            };
        });
    }
    /**
     */
    folderControllerMoveCrateFolderRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.folderControllerMoveCrateFolderRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    folderControllerMoveCrateFolder(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.folderControllerMoveCrateFolderRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for folderControllerMoveFolder without sending the request
     */
    folderControllerMoveFolderRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['moveFolderDto'] == null) {
                throw new runtime.RequiredError('moveFolderDto', 'Required parameter "moveFolderDto" was null or undefined when calling folderControllerMoveFolder().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/folder/move`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: MoveFolderDtoToJSON(requestParameters['moveFolderDto']),
            };
        });
    }
    /**
     */
    folderControllerMoveFolderRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.folderControllerMoveFolderRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    folderControllerMoveFolder(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.folderControllerMoveFolderRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for folderControllerRemoveAllByCrateId without sending the request
     */
    folderControllerRemoveAllByCrateIdRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling folderControllerRemoveAllByCrateId().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/folder/crate/{id}/all`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    folderControllerRemoveAllByCrateIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.folderControllerRemoveAllByCrateIdRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     */
    folderControllerRemoveAllByCrateId(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.folderControllerRemoveAllByCrateIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for folderControllerRemoveCrate without sending the request
     */
    folderControllerRemoveCrateRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling folderControllerRemoveCrate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/folder/crate/{id}`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    folderControllerRemoveCrateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.folderControllerRemoveCrateRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     */
    folderControllerRemoveCrate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.folderControllerRemoveCrateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for folderControllerRemoveCustomFolder without sending the request
     */
    folderControllerRemoveCustomFolderRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling folderControllerRemoveCustomFolder().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/folder/custom-folder/{id}`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    folderControllerRemoveCustomFolderRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.folderControllerRemoveCustomFolderRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    folderControllerRemoveCustomFolder(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.folderControllerRemoveCustomFolderRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for folderControllerRemoveFolder without sending the request
     */
    folderControllerRemoveFolderRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling folderControllerRemoveFolder().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/folder/{id}`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    folderControllerRemoveFolderRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.folderControllerRemoveFolderRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     */
    folderControllerRemoveFolder(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.folderControllerRemoveFolderRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for folderControllerRemoveFolderKeepChildren without sending the request
     */
    folderControllerRemoveFolderKeepChildrenRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling folderControllerRemoveFolderKeepChildren().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/folder/keepChildren/{id}`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    folderControllerRemoveFolderKeepChildrenRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.folderControllerRemoveFolderKeepChildrenRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     */
    folderControllerRemoveFolderKeepChildren(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.folderControllerRemoveFolderKeepChildrenRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for folderControllerUpdate without sending the request
     */
    folderControllerUpdateRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling folderControllerUpdate().');
            }
            if (requestParameters['updateFolderDto'] == null) {
                throw new runtime.RequiredError('updateFolderDto', 'Required parameter "updateFolderDto" was null or undefined when calling folderControllerUpdate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/folder/{id}`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: UpdateFolderDtoToJSON(requestParameters['updateFolderDto']),
            };
        });
    }
    /**
     */
    folderControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.folderControllerUpdateRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    folderControllerUpdate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.folderControllerUpdateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for folderControllerUpdateCustomFolder without sending the request
     */
    folderControllerUpdateCustomFolderRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling folderControllerUpdateCustomFolder().');
            }
            if (requestParameters['updateCustomFolderDto'] == null) {
                throw new runtime.RequiredError('updateCustomFolderDto', 'Required parameter "updateCustomFolderDto" was null or undefined when calling folderControllerUpdateCustomFolder().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/folder/custom-folder/{id}`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: UpdateCustomFolderDtoToJSON(requestParameters['updateCustomFolderDto']),
            };
        });
    }
    /**
     */
    folderControllerUpdateCustomFolderRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.folderControllerUpdateCustomFolderRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    folderControllerUpdateCustomFolder(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.folderControllerUpdateCustomFolderRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for groupControllerAddUserToGroup without sending the request
     */
    groupControllerAddUserToGroupRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['groupId'] == null) {
                throw new runtime.RequiredError('groupId', 'Required parameter "groupId" was null or undefined when calling groupControllerAddUserToGroup().');
            }
            if (requestParameters['addUserToGroupDto'] == null) {
                throw new runtime.RequiredError('addUserToGroupDto', 'Required parameter "addUserToGroupDto" was null or undefined when calling groupControllerAddUserToGroup().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/groups/{groupId}/users`;
            urlPath = urlPath.replace('{groupId}', encodeURIComponent(String(requestParameters['groupId'])));
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: AddUserToGroupDtoToJSON(requestParameters['addUserToGroupDto']),
            };
        });
    }
    /**
     * Add a user to a group
     */
    groupControllerAddUserToGroupRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.groupControllerAddUserToGroupRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Add a user to a group
     */
    groupControllerAddUserToGroup(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.groupControllerAddUserToGroupRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for groupControllerCreateGroup without sending the request
     */
    groupControllerCreateGroupRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['createModifyGroupDto'] == null) {
                throw new runtime.RequiredError('createModifyGroupDto', 'Required parameter "createModifyGroupDto" was null or undefined when calling groupControllerCreateGroup().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/groups`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateModifyGroupDtoToJSON(requestParameters['createModifyGroupDto']),
            };
        });
    }
    /**
     * Create a new group
     */
    groupControllerCreateGroupRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.groupControllerCreateGroupRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Create a new group
     */
    groupControllerCreateGroup(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.groupControllerCreateGroupRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for groupControllerDeleteGroup without sending the request
     */
    groupControllerDeleteGroupRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling groupControllerDeleteGroup().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/groups/{id}`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     * Delete a group
     */
    groupControllerDeleteGroupRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.groupControllerDeleteGroupRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete a group
     */
    groupControllerDeleteGroup(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.groupControllerDeleteGroupRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for groupControllerGetAllGroups without sending the request
     */
    groupControllerGetAllGroupsRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/groups/all`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     * Get all groups (admin only)
     */
    groupControllerGetAllGroupsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.groupControllerGetAllGroupsRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReturnGroupDtoFromJSON));
        });
    }
    /**
     * Get all groups (admin only)
     */
    groupControllerGetAllGroups(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.groupControllerGetAllGroupsRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for groupControllerGetAllUsersInAllGroups without sending the request
     */
    groupControllerGetAllUsersInAllGroupsRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/groups/all-users`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     * Get all users across all groups (admin only)
     */
    groupControllerGetAllUsersInAllGroupsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.groupControllerGetAllUsersInAllGroupsRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get all users across all groups (admin only)
     */
    groupControllerGetAllUsersInAllGroups(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.groupControllerGetAllUsersInAllGroupsRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for groupControllerGetGroupUsers without sending the request
     */
    groupControllerGetGroupUsersRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['groupId'] == null) {
                throw new runtime.RequiredError('groupId', 'Required parameter "groupId" was null or undefined when calling groupControllerGetGroupUsers().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/groups/{groupId}/users`;
            urlPath = urlPath.replace('{groupId}', encodeURIComponent(String(requestParameters['groupId'])));
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     * Get users in a group
     */
    groupControllerGetGroupUsersRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.groupControllerGetGroupUsersRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Get users in a group
     */
    groupControllerGetGroupUsers(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.groupControllerGetGroupUsersRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for groupControllerGetGroupsWhereUserIsOwner without sending the request
     */
    groupControllerGetGroupsWhereUserIsOwnerRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/groups/admin`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     * Get groups where user is owner
     */
    groupControllerGetGroupsWhereUserIsOwnerRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.groupControllerGetGroupsWhereUserIsOwnerRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReturnGroupDtoFromJSON));
        });
    }
    /**
     * Get groups where user is owner
     */
    groupControllerGetGroupsWhereUserIsOwner(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.groupControllerGetGroupsWhereUserIsOwnerRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for groupControllerRemoveUserFromGroup without sending the request
     */
    groupControllerRemoveUserFromGroupRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['groupId'] == null) {
                throw new runtime.RequiredError('groupId', 'Required parameter "groupId" was null or undefined when calling groupControllerRemoveUserFromGroup().');
            }
            if (requestParameters['userId'] == null) {
                throw new runtime.RequiredError('userId', 'Required parameter "userId" was null or undefined when calling groupControllerRemoveUserFromGroup().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/groups/{groupId}/users/{userId}`;
            urlPath = urlPath.replace('{groupId}', encodeURIComponent(String(requestParameters['groupId'])));
            urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));
            return {
                path: urlPath,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     * Remove a user from a group
     */
    groupControllerRemoveUserFromGroupRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.groupControllerRemoveUserFromGroupRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Remove a user from a group
     */
    groupControllerRemoveUserFromGroup(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.groupControllerRemoveUserFromGroupRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for groupControllerUpdateGroup without sending the request
     */
    groupControllerUpdateGroupRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling groupControllerUpdateGroup().');
            }
            if (requestParameters['createModifyGroupDto'] == null) {
                throw new runtime.RequiredError('createModifyGroupDto', 'Required parameter "createModifyGroupDto" was null or undefined when calling groupControllerUpdateGroup().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/groups/{id}`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: CreateModifyGroupDtoToJSON(requestParameters['createModifyGroupDto']),
            };
        });
    }
    /**
     * Update group details
     */
    groupControllerUpdateGroupRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.groupControllerUpdateGroupRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Update group details
     */
    groupControllerUpdateGroup(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.groupControllerUpdateGroupRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for groupControllerUpdateUserGroupPermission without sending the request
     */
    groupControllerUpdateUserGroupPermissionRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['groupId'] == null) {
                throw new runtime.RequiredError('groupId', 'Required parameter "groupId" was null or undefined when calling groupControllerUpdateUserGroupPermission().');
            }
            if (requestParameters['userId'] == null) {
                throw new runtime.RequiredError('userId', 'Required parameter "userId" was null or undefined when calling groupControllerUpdateUserGroupPermission().');
            }
            if (requestParameters['groupControllerUpdateUserGroupPermissionRequest'] == null) {
                throw new runtime.RequiredError('groupControllerUpdateUserGroupPermissionRequest', 'Required parameter "groupControllerUpdateUserGroupPermissionRequest" was null or undefined when calling groupControllerUpdateUserGroupPermission().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/groups/{groupId}/users/{userId}`;
            urlPath = urlPath.replace('{groupId}', encodeURIComponent(String(requestParameters['groupId'])));
            urlPath = urlPath.replace('{userId}', encodeURIComponent(String(requestParameters['userId'])));
            return {
                path: urlPath,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: GroupControllerUpdateUserGroupPermissionRequestToJSON(requestParameters['groupControllerUpdateUserGroupPermissionRequest']),
            };
        });
    }
    /**
     * Update user permission in a group
     */
    groupControllerUpdateUserGroupPermissionRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.groupControllerUpdateUserGroupPermissionRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Update user permission in a group
     */
    groupControllerUpdateUserGroupPermission(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.groupControllerUpdateUserGroupPermissionRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for kartraControllerKartraWebhook without sending the request
     */
    kartraControllerKartraWebhookRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/kartra/webhook`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    kartraControllerKartraWebhookRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.kartraControllerKartraWebhookRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    kartraControllerKartraWebhook(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.kartraControllerKartraWebhookRaw(initOverrides);
        });
    }
    /**
     * Creates request options for keysControllerGetKeyMatches without sending the request
     */
    keysControllerGetKeyMatchesRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['keyDto'] == null) {
                throw new runtime.RequiredError('keyDto', 'Required parameter "keyDto" was null or undefined when calling keysControllerGetKeyMatches().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/keys/key-matches`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: KeyDtoToJSON(requestParameters['keyDto']),
            };
        });
    }
    /**
     */
    keysControllerGetKeyMatchesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.keysControllerGetKeyMatchesRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    keysControllerGetKeyMatches(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.keysControllerGetKeyMatchesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for knownIssueControllerCreate without sending the request
     */
    knownIssueControllerCreateRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['createKnownIssueDto'] == null) {
                throw new runtime.RequiredError('createKnownIssueDto', 'Required parameter "createKnownIssueDto" was null or undefined when calling knownIssueControllerCreate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/known-issues`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateKnownIssueDtoToJSON(requestParameters['createKnownIssueDto']),
            };
        });
    }
    /**
     */
    knownIssueControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.knownIssueControllerCreateRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => KnownIssueDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    knownIssueControllerCreate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.knownIssueControllerCreateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for knownIssueControllerListActive without sending the request
     */
    knownIssueControllerListActiveRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/known-issues`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    knownIssueControllerListActiveRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.knownIssueControllerListActiveRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(KnownIssueDtoFromJSON));
        });
    }
    /**
     */
    knownIssueControllerListActive(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.knownIssueControllerListActiveRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for knownIssueControllerListAll without sending the request
     */
    knownIssueControllerListAllRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/known-issues/all`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    knownIssueControllerListAllRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.knownIssueControllerListAllRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(KnownIssueDtoFromJSON));
        });
    }
    /**
     */
    knownIssueControllerListAll(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.knownIssueControllerListAllRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for knownIssueControllerRemove without sending the request
     */
    knownIssueControllerRemoveRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling knownIssueControllerRemove().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/known-issues/{id}`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    knownIssueControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.knownIssueControllerRemoveRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    knownIssueControllerRemove(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.knownIssueControllerRemoveRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for knownIssueControllerRemovePermanent without sending the request
     */
    knownIssueControllerRemovePermanentRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling knownIssueControllerRemovePermanent().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/known-issues/{id}/permanent`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    knownIssueControllerRemovePermanentRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.knownIssueControllerRemovePermanentRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    knownIssueControllerRemovePermanent(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.knownIssueControllerRemovePermanentRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for knownIssueControllerUpdate without sending the request
     */
    knownIssueControllerUpdateRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling knownIssueControllerUpdate().');
            }
            if (requestParameters['updateKnownIssueDto'] == null) {
                throw new runtime.RequiredError('updateKnownIssueDto', 'Required parameter "updateKnownIssueDto" was null or undefined when calling knownIssueControllerUpdate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/known-issues/{id}`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: UpdateKnownIssueDtoToJSON(requestParameters['updateKnownIssueDto']),
            };
        });
    }
    /**
     */
    knownIssueControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.knownIssueControllerUpdateRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => KnownIssueDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    knownIssueControllerUpdate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.knownIssueControllerUpdateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for lnrpControllerGenerateDownload without sending the request
     */
    lnrpControllerGenerateDownloadRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['lNRPDownloadDto'] == null) {
                throw new runtime.RequiredError('lNRPDownloadDto', 'Required parameter "lNRPDownloadDto" was null or undefined when calling lnrpControllerGenerateDownload().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/lnrp/generate-download`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: LNRPDownloadDtoToJSON(requestParameters['lNRPDownloadDto']),
            };
        });
    }
    /**
     */
    lnrpControllerGenerateDownloadRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.lnrpControllerGenerateDownloadRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => LnrpDownloadResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    lnrpControllerGenerateDownload(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.lnrpControllerGenerateDownloadRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for lnrpControllerLogin without sending the request
     */
    lnrpControllerLoginRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['lnrpLoginDto'] == null) {
                throw new runtime.RequiredError('lnrpLoginDto', 'Required parameter "lnrpLoginDto" was null or undefined when calling lnrpControllerLogin().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/lnrp/login`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: LnrpLoginDtoToJSON(requestParameters['lnrpLoginDto']),
            };
        });
    }
    /**
     */
    lnrpControllerLoginRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.lnrpControllerLoginRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => LnrpLoginResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    lnrpControllerLogin(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.lnrpControllerLoginRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for lnrpControllerLogout without sending the request
     */
    lnrpControllerLogoutRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/lnrp/logout`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    lnrpControllerLogoutRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.lnrpControllerLogoutRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    lnrpControllerLogout(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.lnrpControllerLogoutRaw(initOverrides);
        });
    }
    /**
     * Creates request options for lnrpControllerStatus without sending the request
     */
    lnrpControllerStatusRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/lnrp/status`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    lnrpControllerStatusRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.lnrpControllerStatusRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     */
    lnrpControllerStatus(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.lnrpControllerStatusRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for magicPlaylistControllerGetSpotifyToken without sending the request
     */
    magicPlaylistControllerGetSpotifyTokenRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/magicplaylist/magicPlaylistToken`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    magicPlaylistControllerGetSpotifyTokenRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.magicPlaylistControllerGetSpotifyTokenRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    magicPlaylistControllerGetSpotifyToken(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.magicPlaylistControllerGetSpotifyTokenRaw(initOverrides);
        });
    }
    /**
     * Creates request options for poolsControllerGetAllPools without sending the request
     */
    poolsControllerGetAllPoolsRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/pools/pools`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    poolsControllerGetAllPoolsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.poolsControllerGetAllPoolsRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PoolListDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    poolsControllerGetAllPools(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.poolsControllerGetAllPoolsRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for poolsControllerSearchPools without sending the request
     */
    poolsControllerSearchPoolsRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['poolSearchDto'] == null) {
                throw new runtime.RequiredError('poolSearchDto', 'Required parameter "poolSearchDto" was null or undefined when calling poolsControllerSearchPools().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/pools/search`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: PoolSearchDtoToJSON(requestParameters['poolSearchDto']),
            };
        });
    }
    /**
     */
    poolsControllerSearchPoolsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.poolsControllerSearchPoolsRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PoolTrackDataDtoFromJSON));
        });
    }
    /**
     */
    poolsControllerSearchPools(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.poolsControllerSearchPoolsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for requestnowControllerGetChart without sending the request
     */
    requestnowControllerGetChartRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling requestnowControllerGetChart().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/requestnow/charts/{id}`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    requestnowControllerGetChartRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.requestnowControllerGetChartRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    requestnowControllerGetChart(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestnowControllerGetChartRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for requestnowControllerGetCharts without sending the request
     */
    requestnowControllerGetChartsRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/requestnow/charts`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    requestnowControllerGetChartsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.requestnowControllerGetChartsRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    requestnowControllerGetCharts(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.requestnowControllerGetChartsRaw(initOverrides);
        });
    }
    /**
     * Creates request options for searchControllerSearch without sending the request
     */
    searchControllerSearchRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['searchDto'] == null) {
                throw new runtime.RequiredError('searchDto', 'Required parameter "searchDto" was null or undefined when calling searchControllerSearch().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/search`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SearchDtoToJSON(requestParameters['searchDto']),
            };
        });
    }
    /**
     */
    searchControllerSearchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.searchControllerSearchRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedTrackResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    searchControllerSearch(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchControllerSearchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for smplControllerGetEvent without sending the request
     */
    smplControllerGetEventRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling smplControllerGetEvent().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/smpl/event/{id}`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    smplControllerGetEventRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.smplControllerGetEventRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    smplControllerGetEvent(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.smplControllerGetEventRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for smplControllerGetEvents without sending the request
     */
    smplControllerGetEventsRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/smpl/events`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    smplControllerGetEventsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.smplControllerGetEventsRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    smplControllerGetEvents(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.smplControllerGetEventsRaw(initOverrides);
        });
    }
    /**
     * Creates request options for smplControllerGetSMPLIntegration without sending the request
     */
    smplControllerGetSMPLIntegrationRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/smpl/integration`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    smplControllerGetSMPLIntegrationRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.smplControllerGetSMPLIntegrationRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    smplControllerGetSMPLIntegration(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.smplControllerGetSMPLIntegrationRaw(initOverrides);
        });
    }
    /**
     * Creates request options for smplControllerIntegrateSMPL without sending the request
     */
    smplControllerIntegrateSMPLRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['integrationDto'] == null) {
                throw new runtime.RequiredError('integrationDto', 'Required parameter "integrationDto" was null or undefined when calling smplControllerIntegrateSMPL().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/smpl/integrate`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: IntegrationDtoToJSON(requestParameters['integrationDto']),
            };
        });
    }
    /**
     */
    smplControllerIntegrateSMPLRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.smplControllerIntegrateSMPLRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    smplControllerIntegrateSMPL(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.smplControllerIntegrateSMPLRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for spotifyControllerGetAlbumInfo without sending the request
     */
    spotifyControllerGetAlbumInfoRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['myAlbumInfoIdRequestDto'] == null) {
                throw new runtime.RequiredError('myAlbumInfoIdRequestDto', 'Required parameter "myAlbumInfoIdRequestDto" was null or undefined when calling spotifyControllerGetAlbumInfo().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/spotify/albumInfo/get`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: MyAlbumInfoIdRequestDtoToJSON(requestParameters['myAlbumInfoIdRequestDto']),
            };
        });
    }
    /**
     */
    spotifyControllerGetAlbumInfoRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.spotifyControllerGetAlbumInfoRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    spotifyControllerGetAlbumInfo(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.spotifyControllerGetAlbumInfoRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for spotifyControllerGetAlbumTracks without sending the request
     */
    spotifyControllerGetAlbumTracksRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['myAlbumIdRequestDto'] == null) {
                throw new runtime.RequiredError('myAlbumIdRequestDto', 'Required parameter "myAlbumIdRequestDto" was null or undefined when calling spotifyControllerGetAlbumTracks().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/spotify/album/get`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: MyAlbumIdRequestDtoToJSON(requestParameters['myAlbumIdRequestDto']),
            };
        });
    }
    /**
     */
    spotifyControllerGetAlbumTracksRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.spotifyControllerGetAlbumTracksRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    spotifyControllerGetAlbumTracks(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.spotifyControllerGetAlbumTracksRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for spotifyControllerGetGenres without sending the request
     */
    spotifyControllerGetGenresRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/spotify/genres`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    spotifyControllerGetGenresRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.spotifyControllerGetGenresRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    spotifyControllerGetGenres(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.spotifyControllerGetGenresRaw(initOverrides);
        });
    }
    /**
     * Creates request options for spotifyControllerGetMyPlaylists without sending the request
     */
    spotifyControllerGetMyPlaylistsRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['myPlaylistsRequestDto'] == null) {
                throw new runtime.RequiredError('myPlaylistsRequestDto', 'Required parameter "myPlaylistsRequestDto" was null or undefined when calling spotifyControllerGetMyPlaylists().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/spotify/my/playlists`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: MyPlaylistsRequestDtoToJSON(requestParameters['myPlaylistsRequestDto']),
            };
        });
    }
    /**
     */
    spotifyControllerGetMyPlaylistsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.spotifyControllerGetMyPlaylistsRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    spotifyControllerGetMyPlaylists(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.spotifyControllerGetMyPlaylistsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for spotifyControllerGetPlaylistInfo without sending the request
     */
    spotifyControllerGetPlaylistInfoRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['myPlaylistInfoIdRequestDto'] == null) {
                throw new runtime.RequiredError('myPlaylistInfoIdRequestDto', 'Required parameter "myPlaylistInfoIdRequestDto" was null or undefined when calling spotifyControllerGetPlaylistInfo().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/spotify/playlistInfo/get`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: MyPlaylistInfoIdRequestDtoToJSON(requestParameters['myPlaylistInfoIdRequestDto']),
            };
        });
    }
    /**
     */
    spotifyControllerGetPlaylistInfoRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.spotifyControllerGetPlaylistInfoRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    spotifyControllerGetPlaylistInfo(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.spotifyControllerGetPlaylistInfoRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for spotifyControllerGetPlaylistTracks without sending the request
     */
    spotifyControllerGetPlaylistTracksRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['myPlaylistIdRequestDto'] == null) {
                throw new runtime.RequiredError('myPlaylistIdRequestDto', 'Required parameter "myPlaylistIdRequestDto" was null or undefined when calling spotifyControllerGetPlaylistTracks().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/spotify/playlist/get`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: MyPlaylistIdRequestDtoToJSON(requestParameters['myPlaylistIdRequestDto']),
            };
        });
    }
    /**
     */
    spotifyControllerGetPlaylistTracksRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.spotifyControllerGetPlaylistTracksRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    spotifyControllerGetPlaylistTracks(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.spotifyControllerGetPlaylistTracksRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for trackControllerGetBulkTracks without sending the request
     */
    trackControllerGetBulkTracksRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['bulkTracksRequestDto'] == null) {
                throw new runtime.RequiredError('bulkTracksRequestDto', 'Required parameter "bulkTracksRequestDto" was null or undefined when calling trackControllerGetBulkTracks().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/track/bulk`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: BulkTracksRequestDtoToJSON(requestParameters['bulkTracksRequestDto']),
            };
        });
    }
    /**
     */
    trackControllerGetBulkTracksRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.trackControllerGetBulkTracksRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => BulkTracksResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    trackControllerGetBulkTracks(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.trackControllerGetBulkTracksRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for trackControllerGetCrates without sending the request
     */
    trackControllerGetCratesRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['trackCrateSearchDto'] == null) {
                throw new runtime.RequiredError('trackCrateSearchDto', 'Required parameter "trackCrateSearchDto" was null or undefined when calling trackControllerGetCrates().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/track/crates`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: TrackCrateSearchDtoToJSON(requestParameters['trackCrateSearchDto']),
            };
        });
    }
    /**
     */
    trackControllerGetCratesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.trackControllerGetCratesRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetSimpleCrateDtoFromJSON));
        });
    }
    /**
     */
    trackControllerGetCrates(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.trackControllerGetCratesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for trackControllerGetFeaturesByContentHash without sending the request
     */
    trackControllerGetFeaturesByContentHashRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['contentHash'] == null) {
                throw new runtime.RequiredError('contentHash', 'Required parameter "contentHash" was null or undefined when calling trackControllerGetFeaturesByContentHash().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/track/features/{contentHash}`;
            urlPath = urlPath.replace('{contentHash}', encodeURIComponent(String(requestParameters['contentHash'])));
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    trackControllerGetFeaturesByContentHashRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.trackControllerGetFeaturesByContentHashRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => TrackFeaturesResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    trackControllerGetFeaturesByContentHash(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.trackControllerGetFeaturesByContentHashRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for trackControllerGetTrack without sending the request
     */
    trackControllerGetTrackRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling trackControllerGetTrack().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/track/{id}`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    trackControllerGetTrackRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.trackControllerGetTrackRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => TrackSearchDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    trackControllerGetTrack(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.trackControllerGetTrackRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for trackControllerGetTrackAvailabilityOptions without sending the request
     */
    trackControllerGetTrackAvailabilityOptionsRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/track/availability-options`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    trackControllerGetTrackAvailabilityOptionsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.trackControllerGetTrackAvailabilityOptionsRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => TrackAvailabilityOptionsDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    trackControllerGetTrackAvailabilityOptions(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.trackControllerGetTrackAvailabilityOptionsRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for trackControllerRecommendationSearch without sending the request
     */
    trackControllerRecommendationSearchRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['spotifySearchDto'] == null) {
                throw new runtime.RequiredError('spotifySearchDto', 'Required parameter "spotifySearchDto" was null or undefined when calling trackControllerRecommendationSearch().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/track/recommendation-search`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SpotifySearchDtoToJSON(requestParameters['spotifySearchDto']),
            };
        });
    }
    /**
     */
    trackControllerRecommendationSearchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.trackControllerRecommendationSearchRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TrackFromJSON));
        });
    }
    /**
     */
    trackControllerRecommendationSearch(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.trackControllerRecommendationSearchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for trackControllerSearch without sending the request
     */
    trackControllerSearchRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['spotifySearchDto'] == null) {
                throw new runtime.RequiredError('spotifySearchDto', 'Required parameter "spotifySearchDto" was null or undefined when calling trackControllerSearch().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/track/search`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SpotifySearchDtoToJSON(requestParameters['spotifySearchDto']),
            };
        });
    }
    /**
     */
    trackControllerSearchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.trackControllerSearchRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => TrackFromJSON(jsonValue));
        });
    }
    /**
     */
    trackControllerSearch(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.trackControllerSearchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for trackControllerSyncFeatures without sending the request
     */
    trackControllerSyncFeaturesRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['syncTrackFeaturesRequestDto'] == null) {
                throw new runtime.RequiredError('syncTrackFeaturesRequestDto', 'Required parameter "syncTrackFeaturesRequestDto" was null or undefined when calling trackControllerSyncFeatures().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/track/features/sync`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SyncTrackFeaturesRequestDtoToJSON(requestParameters['syncTrackFeaturesRequestDto']),
            };
        });
    }
    /**
     */
    trackControllerSyncFeaturesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.trackControllerSyncFeaturesRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SyncTrackFeaturesResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    trackControllerSyncFeatures(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.trackControllerSyncFeaturesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for tutorialVideoControllerCreate without sending the request
     */
    tutorialVideoControllerCreateRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['createTutorialVideoDto'] == null) {
                throw new runtime.RequiredError('createTutorialVideoDto', 'Required parameter "createTutorialVideoDto" was null or undefined when calling tutorialVideoControllerCreate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/tutorial-videos`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateTutorialVideoDtoToJSON(requestParameters['createTutorialVideoDto']),
            };
        });
    }
    /**
     */
    tutorialVideoControllerCreateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.tutorialVideoControllerCreateRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => TutorialVideoDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    tutorialVideoControllerCreate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.tutorialVideoControllerCreateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for tutorialVideoControllerListActive without sending the request
     */
    tutorialVideoControllerListActiveRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/tutorial-videos`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    tutorialVideoControllerListActiveRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.tutorialVideoControllerListActiveRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TutorialVideoDtoFromJSON));
        });
    }
    /**
     */
    tutorialVideoControllerListActive(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.tutorialVideoControllerListActiveRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for tutorialVideoControllerListAll without sending the request
     */
    tutorialVideoControllerListAllRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/tutorial-videos/all`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    tutorialVideoControllerListAllRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.tutorialVideoControllerListAllRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TutorialVideoDtoFromJSON));
        });
    }
    /**
     */
    tutorialVideoControllerListAll(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.tutorialVideoControllerListAllRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for tutorialVideoControllerRemove without sending the request
     */
    tutorialVideoControllerRemoveRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling tutorialVideoControllerRemove().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/tutorial-videos/{id}`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    tutorialVideoControllerRemoveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.tutorialVideoControllerRemoveRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    tutorialVideoControllerRemove(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.tutorialVideoControllerRemoveRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for tutorialVideoControllerRemovePermanent without sending the request
     */
    tutorialVideoControllerRemovePermanentRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling tutorialVideoControllerRemovePermanent().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/tutorial-videos/{id}/permanent`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    tutorialVideoControllerRemovePermanentRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.tutorialVideoControllerRemovePermanentRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    tutorialVideoControllerRemovePermanent(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.tutorialVideoControllerRemovePermanentRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for tutorialVideoControllerUpdate without sending the request
     */
    tutorialVideoControllerUpdateRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling tutorialVideoControllerUpdate().');
            }
            if (requestParameters['updateTutorialVideoDto'] == null) {
                throw new runtime.RequiredError('updateTutorialVideoDto', 'Required parameter "updateTutorialVideoDto" was null or undefined when calling tutorialVideoControllerUpdate().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/tutorial-videos/{id}`;
            urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
            return {
                path: urlPath,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: UpdateTutorialVideoDtoToJSON(requestParameters['updateTutorialVideoDto']),
            };
        });
    }
    /**
     */
    tutorialVideoControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.tutorialVideoControllerUpdateRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => TutorialVideoDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    tutorialVideoControllerUpdate(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.tutorialVideoControllerUpdateRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for usersControllerGetBusinessInformation without sending the request
     */
    usersControllerGetBusinessInformationRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/users/business-information`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    usersControllerGetBusinessInformationRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.usersControllerGetBusinessInformationRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    usersControllerGetBusinessInformation(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.usersControllerGetBusinessInformationRaw(initOverrides);
        });
    }
    /**
     * Creates request options for usersControllerGetTeamMembers without sending the request
     */
    usersControllerGetTeamMembersRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/users/team-members`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    usersControllerGetTeamMembersRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.usersControllerGetTeamMembersRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    usersControllerGetTeamMembers(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.usersControllerGetTeamMembersRaw(initOverrides);
        });
    }
    /**
     * Creates request options for usersControllerGetUsersGroups without sending the request
     */
    usersControllerGetUsersGroupsRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/users/groups`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    usersControllerGetUsersGroupsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.usersControllerGetUsersGroupsRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReturnGroupDtoFromJSON));
        });
    }
    /**
     */
    usersControllerGetUsersGroups(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.usersControllerGetUsersGroupsRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for usersControllerGetUsersGroupsWithPermissions without sending the request
     */
    usersControllerGetUsersGroupsWithPermissionsRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/users/groups-with-permissions`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     */
    usersControllerGetUsersGroupsWithPermissionsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.usersControllerGetUsersGroupsWithPermissionsRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    usersControllerGetUsersGroupsWithPermissions(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.usersControllerGetUsersGroupsWithPermissionsRaw(initOverrides);
        });
    }
    /**
     * Creates request options for usersControllerListLifetimeMembers without sending the request
     */
    usersControllerListLifetimeMembersRequestOpts() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/users/lifetime-members`;
            return {
                path: urlPath,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            };
        });
    }
    /**
     * List accounts with Lifetime channel access
     */
    usersControllerListLifetimeMembersRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.usersControllerListLifetimeMembersRequestOpts();
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserFromJSON));
        });
    }
    /**
     * List accounts with Lifetime channel access
     */
    usersControllerListLifetimeMembers(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.usersControllerListLifetimeMembersRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for usersControllerSetLifetimeMembers without sending the request
     */
    usersControllerSetLifetimeMembersRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['setLifetimeMembersDto'] == null) {
                throw new runtime.RequiredError('setLifetimeMembersDto', 'Required parameter "setLifetimeMembersDto" was null or undefined when calling usersControllerSetLifetimeMembers().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/users/lifetime-members`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SetLifetimeMembersDtoToJSON(requestParameters['setLifetimeMembersDto']),
            };
        });
    }
    /**
     * Most lifetime members come from the Kartra \"CH Lifetime Deal\" tag, which is synced on login. This adds or removes a manual grant on top of that, for accounts the tag misses. Revoking will not remove access from someone who still carries the tag; those emails are returned in stillMemberViaKartra.
     * Manually grant or revoke Lifetime channel access for a list of emails
     */
    usersControllerSetLifetimeMembersRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.usersControllerSetLifetimeMembersRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Most lifetime members come from the Kartra \"CH Lifetime Deal\" tag, which is synced on login. This adds or removes a manual grant on top of that, for accounts the tag misses. Revoking will not remove access from someone who still carries the tag; those emails are returned in stillMemberViaKartra.
     * Manually grant or revoke Lifetime channel access for a list of emails
     */
    usersControllerSetLifetimeMembers(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.usersControllerSetLifetimeMembersRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Creates request options for usersControllerUpdateDjSoftware without sending the request
     */
    usersControllerUpdateDjSoftwareRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['updateUserDjSoftwareDto'] == null) {
                throw new runtime.RequiredError('updateUserDjSoftwareDto', 'Required parameter "updateUserDjSoftwareDto" was null or undefined when calling usersControllerUpdateDjSoftware().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/users/dj-software`;
            return {
                path: urlPath,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: UpdateUserDjSoftwareDtoToJSON(requestParameters['updateUserDjSoftwareDto']),
            };
        });
    }
    /**
     * Set or update user’s DJ software list
     */
    usersControllerUpdateDjSoftwareRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.usersControllerUpdateDjSoftwareRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserFromJSON(jsonValue));
        });
    }
    /**
     * Set or update user’s DJ software list
     */
    usersControllerUpdateDjSoftware(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.usersControllerUpdateDjSoftwareRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Creates request options for usersControllerUpdateUserKartraApi without sending the request
     */
    usersControllerUpdateUserKartraApiRequestOpts(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['kartraGenericDto'] == null) {
                throw new runtime.RequiredError('kartraGenericDto', 'Required parameter "kartraGenericDto" was null or undefined when calling usersControllerUpdateUserKartraApi().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("JWT", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            let urlPath = `/users/kartra-update`;
            return {
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: KartraGenericDtoToJSON(requestParameters['kartraGenericDto']),
            };
        });
    }
    /**
     * Call generic Kartra API command
     */
    usersControllerUpdateUserKartraApiRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestOptions = yield this.usersControllerUpdateUserKartraApiRequestOpts(requestParameters);
            const response = yield this.request(requestOptions, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Call generic Kartra API command
     */
    usersControllerUpdateUserKartraApi(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.usersControllerUpdateUserKartraApiRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
